import { createFileRoute } from "@tanstack/react-router";
import { JaziaForgotPassword } from "@/components/forgot/JaziaForgotPassword";

export const Route = createFileRoute("/forgot-password")({
  component: JaziaForgotPassword,
});
